import MethodsListsBlocksList from './MethodsListsBlocksList';

export default MethodsListsBlocksList;